import SolutionAdditionalMaterials from './solution-blocks/solution-additional-materials/solution-additional-materials';
import SolutionMoreCases from './solution-blocks/solution-more-cases/solution-more-cases';
import SolutionTeam from './solution-blocks/solution-team/solution-team';
import SolutionVendors from './solution-blocks/solution-vendors/solution-vendors';
import SolutionGallerySolutions from './solution-blocks/solution-gallery-solutions/solution-gallery-solutions';
import SolutionSolutionsWithDescription from './solution-blocks/solution-solutions-with-description/solution-solutions-with-description';

import HomepageCompetenceCenter from './homepage-blocks/homepage-competence-center';
import HomepageOurProjects from './homepage-blocks/homepage-our-projects';
import HomepageSpecProjects from './homepage-blocks/homepage-spec-projects';
import Header from './techart-theme/header';

$(() => {
	const blocks = [
		{
			className: SolutionVendors
		},
		{
			className: SolutionMoreCases
		},
		{
			className: SolutionTeam
		}
		,
		{
			className: SolutionAdditionalMaterials
		}
		,
		{
			className: SolutionGallerySolutions
		}
		,
		{
			className: SolutionSolutionsWithDescription
		}
		,
		{
			className: HomepageCompetenceCenter
		}
		,
		{
			className: HomepageOurProjects
		}
		,
		{
			className: HomepageSpecProjects
		}
		,
		{
			className: Header
		}
	];

	blocks.forEach(elem => {
		$(`.${elem.className.block_name}`).each(function() {
			const obj = new elem.className($(this));
			obj.onInit();
		})
	});
});
